import apiClient from "./api";
//获取客户中心配置
export function clientPortalSettings() {
    const workspaceId = localStorage.getItem("workspaceId");
    return apiClient.get(`/v1/client-portal/config`, {
        headers: {
            "X-Workspace-Id": workspaceId
        }
    });
}